
import { defineComponent } from "@vue/runtime-core";
import { mapMutations, mapState } from "vuex";
import LoginForm from "./LoginForm.vue";
import RegisterForm from "./RegisterForm.vue";

export default defineComponent({
  name: "Auth",
  components: {
    LoginForm,
    RegisterForm
  },
  data() {
    return {
      showingLogin: true,
    }
  },
  computed: {
    //simple getter
    //...mapState(['authModalShow']),
    // named getter for state
    ...mapState({
      getModalState: "authModalShow",
    })
  },
  methods: {
    ...mapMutations(["toggleAuthModal"]),
    toggleForm() {
      this.showingLogin = !this.showingLogin;
    },
    getButtonStyle(showingLogin: boolean) {
      return {
        "bg-blue-600": showingLogin,
        "text-white": showingLogin,
        "hover:text-white": showingLogin,
        "hover:text-blue-600": !showingLogin
      };
    }
  }
});
